import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { AppProviders } from "./app/providers";
import { AppRouter } from "./app/router";

// The default Azure address is not where the PMS lives: send anyone there to the published name.
const CANONICAL: string = import.meta.env["VITE_CANONICAL_ORIGIN"] ?? "";
if (
  CANONICAL &&
  window.location.origin !== CANONICAL &&
  window.location.hostname.endsWith(".azurestaticapps.net")
) {
  window.location.replace(
    CANONICAL + window.location.pathname + window.location.search + window.location.hash,
  );
}

const container = document.getElementById("root");
if (container === null) throw new Error("No #root element in index.html");

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
